exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.payment-icon {*/\n\n/*width: 90px;*/\n\n/*border-radius: 20px;*/\n\n/*border: 1px solid #ccc;*/\n\n/*}*/\n", ""]);

// exports
